
export const SCORE_WORDS = { 50: 'Verified', 40: 'Mostly verified', 30: 'Partly verified', 20: 'Weak match', 10: 'Very weak', 0: 'Nothing verified' }

export const BUSINESS_GROUPS = ['Watchlist', 'Identity', 'Address', 'Phone', 'EIN', 'Age and standing', 'Not sent']
export const OWNER_GROUPS = ['Watchlist', 'Identity and SSN', 'Address', 'Phone', 'Not sent']

const c = (group, tone, label) => ({ group, tone, label })

export const BUSINESS_CODES = {
    10: c('Watchlist', 'declined', 'Business name matches the OFAC list'),
    12: c('Age and standing', 'declined', 'Bankruptcy on record suggests the business may be closed'),
    13: c('Age and standing', 'declined', 'Not in good standing with the Secretary of State'),
    14: c('Age and standing', 'declined', 'Inactive with the Secretary of State'),
    15: c('Age and standing', 'declined', 'Not registered with the Secretary of State of its state'),
    16: c('EIN', 'declined', 'EIN belongs to a different business name and address'),
    17: c('Identity', 'watch', 'Name, address, EIN and phone not found on business records'),
    18: c('Identity', 'neutral', 'Name not found on business records, but the alternate name was'),
    19: c('Identity', 'watch', 'Business name not found on business records'),
    20: c('Address', 'watch', 'Address not found on business records'),
    21: c('EIN', 'neutral', 'EIN not found on business records'),
    22: c('Phone', 'neutral', 'Phone not found on business records'),
    23: c('Age and standing', 'watch', 'First reported in the last 12 months'),
    24: c('Age and standing', 'neutral', 'First reported in the last 24 months'),
    25: c('Address', 'neutral', 'Address may be a previous address'),
    27: c('Address', 'watch', 'Address is vacant'),
    28: c('Phone', 'watch', 'Phone may be disconnected'),
    29: c('Phone', 'watch', 'Phone belongs to a different name and address'),
    30: c('Address', 'watch', 'May be a post office box'),
    31: c('Phone', 'neutral', 'Phone is a mobile number'),
    34: c('Address', 'neutral', 'Address may be a home'),
    35: c('Phone', 'neutral', 'Phone may be a residential listing'),
    36: c('Phone', 'neutral', 'Phone and address on record are more than 10 miles apart'),
    37: c('EIN', 'neutral', 'EIN not found'),
    38: c('Age and standing', 'neutral', 'No updates to the business record in the last 36 months'),
    39: c('Age and standing', 'neutral', 'No updates to the business record in the last 24 months'),
    40: c('Age and standing', 'neutral', 'No updates to the business record in the last 12 months'),
    41: c('Address', 'neutral', 'Operates or has operated at several locations'),
    43: c('Address', 'watch', 'Address may be invalid (postal check)'),
    44: c('Phone', 'watch', 'Phone may be invalid'),
    45: c('EIN', 'watch', 'EIN may be invalid'),
    46: c('Identity', 'neutral', 'Name matches the alternate name sent'),
    47: c('Identity', 'neutral', 'Name may have a typo'),
    48: c('Address', 'neutral', 'Address may have a typo'),
    49: c('Phone', 'neutral', 'Phone may have a typo'),
    50: c('EIN', 'neutral', 'EIN may have a typo'),
    53: c('Not sent', 'notSent', 'Business phone not sent'),
    54: c('Not sent', 'notSent', 'EIN not sent'),
}

export const OWNER_CODES = {
    32: c('Watchlist', 'declined', 'Name matches the OFAC list'),
    DI: c('Identity and SSN', 'declined', 'Reported deceased'),
    '02': c('Identity and SSN', 'declined', 'SSN belongs to a person reported deceased'),
    '06': c('Identity and SSN', 'declined', 'SSN is not valid'),
    '03': c('Identity and SSN', 'declined', 'SSN was issued before the date of birth'),
    MI: c('Identity and SSN', 'declined', 'Several identities use this SSN'),
    MS: c('Identity and SSN', 'declined', 'Several SSNs reported for this person'),
    IT: c('Identity and SSN', 'watch', 'An ITIN was sent instead of an SSN'),
    71: c('Identity and SSN', 'watch', 'SSN not found in public records'),
    72: c('Identity and SSN', 'watch', 'SSN belongs to a different name and address'),
    51: c('Identity and SSN', 'watch', 'Last name does not go with the SSN'),
    52: c('Identity and SSN', 'watch', 'First name does not go with the SSN'),
    38: c('Identity and SSN', 'watch', 'SSN used with several last names'),
    CL: c('Identity and SSN', 'watch', "SSN is not this person's main SSN"),
    26: c('Identity and SSN', 'watch', 'SSN could not be verified'),
    19: c('Identity and SSN', 'watch', 'Name, address, SSN and phone could not be verified'),
    37: c('Identity and SSN', 'watch', 'Name could not be verified'),
    48: c('Identity and SSN', 'watch', 'First name could not be verified'),
    28: c('Identity and SSN', 'watch', 'Date of birth could not be verified'),
    RS: c('Identity and SSN', 'neutral', 'SSN was randomly issued (normal for SSNs issued since 2011)'),
    90: c('Identity and SSN', 'neutral', 'SSN was issued after age five'),
    85: c('Identity and SSN', 'neutral', 'SSN was issued to a non-US citizen'),
    66: c('Identity and SSN', 'neutral', 'SSN also used with a different last name'),
    76: c('Identity and SSN', 'neutral', 'Name may have a typo'),
    83: c('Identity and SSN', 'neutral', 'Date of birth may have a typo'),
    NB: c('Identity and SSN', 'neutral', 'No date of birth on file for this person'),
    '04': c('Identity and SSN', 'neutral', 'Last name and SSN verified, but not with the address and phone'),
    41: c('Identity and SSN', 'neutral', "Driver's license number is not valid for its state"),
    VA: c('Address', 'watch', 'Address is vacant'),
    CA: c('Address', 'watch', 'Address is a mail drop (commercial mail receiving agency)'),
    PO: c('Address', 'watch', 'Address is a PO box'),
    12: c('Address', 'watch', 'ZIP code belongs to a PO box'),
    14: c('Address', 'watch', 'Address is transient, commercial or institutional'),
    25: c('Address', 'neutral', 'Address could not be verified'),
    11: c('Address', 'neutral', 'Address may be invalid (postal check)'),
    SD: c('Address', 'neutral', 'Address is in a different state than the best address on record'),
    PA: c('Address', 'neutral', 'Address may be a previous address'),
    SR: c('Address', 'neutral', 'Unit or suite number does not match'),
    ZI: c('Address', 'neutral', 'ZIP code could not be verified'),
    30: c('Address', 'neutral', 'Address may have a typo'),
    10: c('Phone', 'neutral', 'Phone is a mobile number'),
    27: c('Phone', 'neutral', 'Phone could not be verified'),
    82: c('Phone', 'neutral', 'Name and address go with a different phone'),
    74: c('Phone', 'neutral', 'Phone belongs to a different name and address'),
    64: c('Phone', 'neutral', 'Address goes with a different phone'),
    49: c('Phone', 'neutral', 'Phone and address are more than 10 miles apart'),
    '08': c('Phone', 'neutral', 'Phone may be invalid'),
    16: c('Phone', 'neutral', 'Phone and ZIP code do not go together'),
    44: c('Phone', 'neutral', 'Phone area code is changing'),
    '07': c('Phone', 'neutral', 'Phone may be disconnected'),
    75: c('Phone', 'neutral', 'Unlisted phone for this name and address'),
    31: c('Phone', 'neutral', 'Phone may have a typo'),
    79: c('Not sent', 'notSent', 'SSN not sent'),
    81: c('Not sent', 'notSent', 'Date of birth not sent'),
    80: c('Not sent', 'notSent', 'Phone not sent'),
    78: c('Not sent', 'notSent', 'Address not sent'),
}

export const FOLLOW_UPS = {
    A: 'Follow your internal policy on possible OFAC matches',
    B: "Verify name with SSN (SSN card, driver's license, pay stub or other government ID)",
    C: "Verify name with address (driver's license, utility bill, pay stub or other government ID)",
    D: 'Verify phone (directory assistance or utility bill)',
    F: 'Ask for a utility bill or other proof of a physical address',
    G: "ITINs are not for ID purposes; check your organization's policy",
}

export const SOURCES = {
    GOVTREGISTRATIONS: 'Government registrations',
    BUREAU: 'Credit bureau',
    PUBLICRECORDFILINGS: 'Public filings',
    BUSDIRECTORIES: 'Business directories',
    PHONESOURCE: 'Phone listings',
}

export const ADDRESS_TYPES = { 0: 'Commercial address', 1: 'Possible sole proprietor', 2: 'Possible home office' }

export const PHONE_SOURCES = { A: 'phone listing', S: 'customer network', P: 'phone records', I: 'Lexis records', U: 'utility records' }

const MATCHED = {
    2: ['first name', 'last name'], 3: ['first name', 'address'], 4: ['first name', 'X'], 5: ['last name', 'address'],
    6: ['address', 'X'], 7: ['last name', 'X'], 8: ['first name', 'last name', 'address'], 9: ['first name', 'last name', 'X'],
    10: ['first name', 'address', 'X'], 11: ['last name', 'address', 'X'], 12: ['first name', 'last name', 'address', 'X'],
}

export function describeSummary(value, what) {
    const n = Number(value)
    if (value == null || value === '' || isNaN(n)) return null
    if (n === 0) return { text: 'Nothing matched', tone: 'watch' }
    if (n === 1) return { text: `${what} belongs to a different name and address`, tone: 'watch' }
    const parts = (MATCHED[n] || []).map(p => (p === 'X' ? what : p))
    if (!parts.length) return { text: `Lexis code ${n}`, tone: 'neutral' }
    const names = parts.includes('first name') && parts.includes('last name')
        ? ['name', ...parts.filter(p => p !== 'first name' && p !== 'last name')] : parts
    const sentence = names.length > 1 ? `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}` : names[0]
    return { text: `${sentence.charAt(0).toUpperCase()}${sentence.slice(1)} match`, tone: n === 12 ? 'approved' : 'watch' }
}

const DOB_MATCH = {
    1: 'Does not match', 2: 'Only the day matches', 3: 'Only the month matches', 4: 'Day and month match, year differs',
    5: 'Day and year match, month differs', 6: 'Only the year matches', 7: 'Month and year match, day differs', 8: 'Matches the record',
}

export function describeDobMatch(value, sent) {
    if (!sent) return { text: 'Not sent', tone: 'notSent' }
    const n = Number(value)
    if (!n) return { text: 'No date of birth on file', tone: 'neutral' }
    return { text: DOB_MATCH[n] || `Lexis code ${n}`, tone: n === 8 ? 'approved' : 'watch' }
}

const LINKS = [
    [/cannot be linked/i, 'Cannot be linked to the business', 'watch'],
    [/SSN matches the SSN of a business contact/i, 'SSN matches a business contact', 'approved'],
    [/first and last name matches/i, 'Name matches a business contact', 'approved'],
    [/address and first or last name/i, "Address and part of the name match the business's record", 'approved'],
    [/personal address of a business contact/i, "Address matches a business contact's home", 'approved'],
    [/address matches the business address/i, 'Address matches the business address on record', 'neutral'],
    [/phone matches the business phone/i, 'Phone matches the business phone on record', 'neutral'],
    [/SSN is the same as the input business FEIN/i, "Owner's SSN was sent as the business EIN", 'watch'],
    [/phone is the same as the input business phone/i, 'Same phone as the business', 'neutral'],
    [/appears as part of the (input )?business name/i, 'Name is part of the business name', 'neutral'],
]

export function describeLink(link) {
    if (!link || typeof link !== 'object') return null
    const description = typeof link.Description === 'string' ? link.Description : ''
    const index = typeof link.Index === 'string' || typeof link.Index === 'number' ? String(link.Index).trim() : ''
    if (!description && !index) return null
    const found = LINKS.find(([re]) => re.test(description))
    if (found) return { text: found[1], tone: found[2], index: Number(index) }
    return { text: description || `Link score ${index}`, tone: Number(index) >= 40 ? 'approved' : Number(index) === 0 ? 'watch' : 'neutral', index: Number(index) }
}
